import { FiscalPrintEnabledQuery } from '@dreryk/egabinet-invoice-frontend-api';

import { useCqrsFind } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { invoiceSharedTranslationKeys } from '../translations';

type InvoiceFiscalPrintIntegrationToggleRenderProps = {
   fiscalPrintIntegrationEnabled: boolean;
};

type InvoiceFiscalPrintIntegrationToggleLoaderProps = {
   readonly children: (renderProps: InvoiceFiscalPrintIntegrationToggleRenderProps) => JSX.Element;
};

export const InvoiceFiscalPrintIntegrationToggleLoader = (
   props: InvoiceFiscalPrintIntegrationToggleLoaderProps
): JSX.Element => {
   const {
      data: fiscalPrintIntegrationEnabled,
      loading: fiscalPrintIntegrationEnabledLoading,
      error: fiscalPrintIntegrationEnabledError,
   } = useCqrsFind(() => new FiscalPrintEnabledQuery());

   if (fiscalPrintIntegrationEnabledLoading) {
      return <LoaderSpinner />;
   }

   if (fiscalPrintIntegrationEnabledError) {
      return (
         <Message
            testId={'failedToFetchData'}
            label={invoiceSharedTranslationKeys.fetchError}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      fiscalPrintIntegrationEnabled: Boolean(fiscalPrintIntegrationEnabled),
   });
};
